module.exports = __webpack_public_path__ + "static/wild-swans-dca7942048520c4b8fc60a845f63e538.jpg";